import { Link, useTrackCampaign } from '@packages/shared';
import { PromotionBannerTestIds } from '../PromotionBannerTestIds';
import type { LinkPromotion } from '../types';

export const PromotionAsLink = ({ data }: { data: LinkPromotion }): JSX.Element => {
  const trackOnClick = useTrackCampaign(data);

  return (
    <Link
      href={data.linkReady}
      data-testid={PromotionBannerTestIds.asLink}
      noLinkStyle
      onClick={() => trackOnClick()}
    >
      {data.title}
    </Link>
  );
};
